/*
 * RoutesManager Messages
 *
 * This contains all the text for the RoutesManager component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.RouteControls.manageRoutes',
    defaultMessage: 'Manage routes',
  },
  sortRoutes: {
    id: 'app.components.RoutesManager.sortRoutes',
    defaultMessage: 'Click on the label on top of a column to sort the table.',
  },
  filterRoutes: {
    id: 'app.components.RoutesManager.filterRoutes',
    defaultMessage: 'Type text in the filter field to find a route.',
  },
  noRoutes: {
    id: 'app.components.RoutesManager.noRoutes',
    defaultMessage: 'No routes found.',
  },
  numberRoutes: {
    id: 'app.components.RoutesManager.numberRoutes',
    defaultMessage: 'Number of routes: ',
  },
  outOf: {
    id: 'app.components.RoutesManager.outOf',
    defaultMessage: '<b>{filterCount}</b> of <b>{totalCount}</b>',
  },
  title: {
    id: 'app.components.RoutesManager.title',
    defaultMessage: 'Name',
  },
  city: {
    id: 'app.components.RoutesManager.city',
    defaultMessage: 'City',
  },
  distance: {
    id: 'app.components.RoutesManager.distance',
    defaultMessage: 'Distance',
  },
  public: {
    id: 'app.components.RoutesManager.public',
    defaultMessage: 'Public',
  },
  modified: {
    id: 'app.components.RoutesManager.modified',
    defaultMessage: 'Updated',
  },
  confirmDelete: {
    id: 'app.components.RoutesManager.confirmDelete',
    defaultMessage: "Delete route '{title}'?",
  },
});
